import React from 'react';
import './AdvantagesSection.scss';

export default function AdvantagesSection() {
    return (
        <section className="advantages-section">
            <h2 className="section-title">Pourquoi choisir TheSpot ?</h2>
            <div className="advantages-container">
                <div className="advantage-item">
                    <div className="advantage-image">
                        <img src="/assets/images/screenshots/map.png" alt="Carte interactive & filtres" />
                    </div>
                    <div className="advantage-text">
                        <h3>Carte intuitive & filtres intelligents</h3>
                        <p>
                            Repérez instantanément tous les restaurants à proximité grâce à notre <span className="highlight">carte interactive</span> simple d’utilisation, agrémentée de <span className="highlight">filtres intelligents</span> pour affiner votre recherche en quelques clics.
                        </p>
                    </div>
                </div>

                <div className="advantage-item">
                    <div className="advantage-image">
                        <img src="/assets/images/screenshots/flashspot.png" alt="FlashSpot sur-mesure" />
                    </div>
                    <div className="advantage-text">
                        <h3>Découverte sur-mesure</h3>
                        <p>
                            Laissez TheSpot créer pour vous une <span className="highlight">expérience unique</span> en vous proposant une sélection de trois restaurants adaptés à vos envies. Personnalisez vos critères et laissez le <span className="highlight">hasard</span> vous surprendre.
                        </p>
                    </div>
                </div>

                <div className="advantage-item">
                    <div className="advantage-image">
                        <img src="/assets/images/screenshots/spot.png" alt="Infos du Spot en un coup d'œil" />
                    </div>
                    <div className="advantage-text">
                        <h3>Infos complètes en un instant</h3>
                        <p>
                            Accédez rapidement à toutes les informations essentielles – <span className="highlight">prix</span>, <span className="highlight">avis</span>, <span className="highlight">horaires</span> – pour choisir votre prochain spot en toute simplicité.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
